import { Component, OnInit } from "@angular/core";

@Component({
  selector: "mydocuments",
  templateUrl: "./mydocuments.component.html",
  styleUrls: ["./mydocuments.scss"],
})
export class MyDocumentsComponent implements OnInit {
  constructor() {}

  tabselector: string;

  ngOnInit(): void {
    this.tabselector = "tabs1";
  }

  tabClick(clickedTab) {
    this.tabselector = clickedTab;
  }
}
